// import { BarcodeFormat, Result, } from "@zxing/library";
import {
  BarcodeFormat,
  BrowserMultiFormatReader,
  NotFoundException,
} from "@zxing/library";
import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { buttonContainer } from "../../pages/UserInformation/styles";
import { scannerBox, startButton } from "./styles";
import { DecodeHintType } from "react-zxing";
import { showToast } from "../../services/toast";

type Props = {
  setBarCode: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDetectCount: React.Dispatch<React.SetStateAction<number>>;
  setIsScaned: React.Dispatch<React.SetStateAction<boolean>>;
  codeReader: BrowserMultiFormatReader;
};

const IDCardReader = (props: Props) => {
  const [selectedDeviceId, setSelectedDeviceId] = useState<
    string | undefined
  >();
  const [result, setResult] = useState<string>("");
  const [scanning, setScanning] = useState(false);
  let codeReader = props.codeReader;

  const hints = new Map();
  const formats = [BarcodeFormat.EAN_13];
  hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
  codeReader.hints = hints;

  useEffect(() => {
    const handlePopState = (event: { preventDefault: () => void }) => {
      event.preventDefault();
      codeReader.reset();
      props.setOpen(false);
    };
    window.addEventListener("popstate", handlePopState);
    window.history.pushState({ modalOpened: false }, "");

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    // const hints = new Map();
    // const formats = [BarcodeFormat.EAN_13];
    // hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
    // const codeReader = new BrowserMultiFormatReader(hints);

    let initScanner = () => {
      //codeReader.tryPlayVideo(document.getElementById("video") as HTMLVideoElement)
      codeReader
        .listVideoInputDevices()
        .then((videoInputDevices: MediaDeviceInfo[]) => {
          if (videoInputDevices.length > 0) {
            const backCamera = videoInputDevices.find(
              (device) =>
                device.label.toLowerCase().includes("back") ||
                device.label.toLowerCase().includes("rear")
            );
            setSelectedDeviceId((backCamera || videoInputDevices[0]).deviceId);
          } else { return showToast("Could not initialize camera", "error"); }

          const sourceSelect = document.getElementById(
            "sourceSelect"
          ) as HTMLSelectElement;
          if (sourceSelect) {
            videoInputDevices.forEach((device) => {
              const sourceOption = document.createElement("option");
              sourceOption.text = device.label;
              sourceOption.value = device.deviceId;
              sourceSelect.appendChild(sourceOption);
            });
          }
        })
        .catch((err: Error) => {
          console.error("Error listing video input devices:", err);
        });
    };

    if (!navigator.permissions) {

      initScanner();
    } else {
      navigator.permissions
        .query({ name: "camera" as PermissionName })
        .then((res) => {
          if (res.state != "granted") {
            navigator.mediaDevices
              .getUserMedia({ video: true })
              .then((mediaRes) => {
                initScanner();
              });
          } else if (res.state == "granted") {
            initScanner();
          }
        })
        .catch((err) => {
          showToast("Could not initialize camera", "error");
          
        });
    }

    return () => {
      codeReader.reset();
    };
  }, []);

  const startScanning = () => {
    if (selectedDeviceId) {
      // const hints = new Map();
      // const formats = [BarcodeFormat.PDF_417];
      // hints.set(DecodeHintType.POSSIBLE_FORMATS, formats);
      // const codeReader = new BrowserMultiFormatReader(hints);
      // const codeReader = new BrowserMultiFormatReader();
      setScanning(true);
      codeReader.decodeFromVideoDevice(
        selectedDeviceId,
        "video",
        (result, err) => {
          if (result) {
            console.log(result);
            codeReader.reset();
            props.setBarCode(result.getText());
            props.setOpen(false);
            props.setIsScaned(true);
            setScanning(false);
          }
          if (err && !(err instanceof NotFoundException)) {
            console.error(err);
            setResult(err.toString());
            codeReader.reset();
            setScanning(false);
          }
        }
      );
      console.log(
        `Started continuous decode from camera with id ${selectedDeviceId}`
      );
    }

    let timer: NodeJS.Timeout;
    timer = setTimeout(() => {
      props.setDetectCount((preCount) => {
        if (preCount < 2) {
          showToast("Barcode was not scanned, please try again.", "error");
        } else {
          showToast(
            "Barcode was not scanned, please take picture instead.",
            "error"
          );
          props.setOpen(false);
          props.setIsScaned(true);
        }
        return preCount + 1;
      });
      setScanning(false);
      codeReader.reset();
    }, 10000);
    return () => {
      clearTimeout(timer);
    };
  };

  const resetScanner = () => {
    const codeReader = new BrowserMultiFormatReader();
    codeReader.reset();
    setResult("");
    setScanning(false);
    console.log("Reset.");
  };

  const handleDeviceChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDeviceId(event.target.value);
  };

  return (
    // <main className="wrapper" style={{ paddingTop: "2em" }}>
    //   <section className="container" id="demo-content">
    //     <h1 className="title">Scan 1D/2D Code from Video Camera</h1>

    //     <p>
    //       <a className="button-small button-outline" href="../../index.html">
    //         HOME 🏡
    //       </a>
    //     </p>

    //     <p>
    //       This example shows how to scan any supported 1D/2D code with ZXing
    //       JavaScript library from the device video camera. If more than one
    //       video input devices are available (for example front and back camera),
    //       the example shows how to read them and use a select to change the
    //       input device.
    //     </p>

    //     <div>
    //       <button className="button" onClick={startScanning}>
    //         Start
    //       </button>
    //       <button className="button" onClick={resetScanner}>
    //         Reset
    //       </button>
    //     </div>

    //     <div>
    //       <video
    //         id="video"
    //         width="300"
    //         height="200"
    //         style={{ border: "1px solid gray" }}
    //       ></video>
    //     </div>

    //     <div id="sourceSelectPanel" style={{ display: "none" }}>
    //       <label htmlFor="sourceSelect">Change video source:</label>
    //       <select
    //         id="sourceSelect"
    //         style={{ maxWidth: "400px" }}
    //         onChange={handleDeviceChange}
    //       >
    //         {/* Options will be dynamically populated */}
    //       </select>
    //     </div>

    //     <label>Result:</label>
    //     <pre>
    //       <code id="result">{result}</code>
    //     </pre>

    //     <p>
    //       See the{" "}
    //       <a href="https://github.com/zxing-js/library/tree/master/docs/examples/multi-camera/">
    //         source code
    //       </a>
    //       for this example.
    //     </p>
    //   </section>

    //   <footer className="footer">
    //     <section className="container">
    //       <p>
    //         ZXing TypeScript Demo. Licensed under the{" "}
    //         <a
    //           target="_blank"
    //           href="https://github.com/zxing-js/library#license"
    //           title="MIT"
    //         >
    //           MIT
    //         </a>
    //         .
    //       </p>
    //     </section>
    //   </footer>
    // </main>
    <Box>
      <Box sx={scanning ? (theme) => scannerBox(theme) : () => null}>
        <video
          id="video"
          width="100%"
          height="500"
          style={{ border: "1px solid gray" }}
        ></video>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Button
          sx={(theme) => startButton(theme)}
          onClick={() => {
            startScanning();
          }}
        >
          Start Scanning
        </Button>
      </Box>
    </Box>
  );
};

export default IDCardReader;
